<template>
    <div class="app">
        <HeaderDefault />

        <GroupAdmin />

        <FooterDefault />
    </div>
</template>

<script setup>
import HeaderDefault from '@/components/Header/HeaderDefault.vue'
import FooterDefault from '@/components/Footer/FooterDefault.vue'
import GroupAdmin from '@/components/Group/GroupAdmin.vue';
</script>